export const environment = {
    ENV: 'dev',
    redirectUri: 'redirect_URL', // Dummy URL Will be replaced later
    refreshTokenApi: 'refresh_Token_Api'
}